import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit, Input } from '@angular/core';
import { TypeTacheService } from '../../../services/typeTache.service';
import { Typetache } from '../../../models/typetache.model';
import { environment } from '../../../../environments/environment';
import { Tache } from '../../../models/tache.model';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'ngx-app-tache-list',
  templateUrl: './tache-list.component.html',
  styleUrls: ['./tache-list.component.scss']
})
export class TacheListComponent implements OnInit {

  @Input() taches;
  @Input() typeTaches;
  @Input() typesalleId;
  status: string;
  tachesTemp: Tache[];
  dateNow = new Date();
  dateExec: Date = new Date();
  constructor(private translate: TranslateService, private datePipe: DatePipe){
  }


  ngOnInit() {
    // On filtre les types de tâche et on leur associe le bon nombre de taches.
    this.typeTaches = this.typeTaches.filter(t => t.typesalle.id === this.typesalleId);
    for (let i = 0; i < this.typeTaches.length; i++) {
      this.tachesTemp = this.taches.filter(t => t.typetache.id === this.typeTaches[i].id);
      this.typeTaches[i].nbTaches = this.tachesTemp.length;
      if(this.typeTaches[i].nbTaches > 0) {
        this.tachesTemp.sort((a, b) => (a.datefintache > b.datefintache) ? 1 : -1);
        let dateExec = new Date(this.tachesTemp[0].datefintache);
        this.typeTaches[i].dateExec = dateExec.getTime();
      }
      if (this.typeTaches[i].nbTaches === 0) {
        this.typeTaches[i].status = '0';
      }else if (this.typeTaches[i].dateExec - this.typeTaches[i].retardAdmissible < this.dateNow.getTime()) {
        this.typeTaches[i].status = '1';
      }else if (this.typeTaches[i].dateExec < this.dateNow.getTime()) {
        this.typeTaches[i].status = '2';
      }else{
        this.typeTaches[i].status = '3';
      }
    }
  }
}
